/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import {
  makeStyles,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import {
  React,
} from 'react';

import { StyledTableCell, StyledTableRow } from '../utils/StyledTable';

const useStyles = makeStyles(() => ({
  cell: {
    size: 'small',
    whiteSpace: 'nowrap',
  },
  cellwrap: {
    size: 'small',
    whiteSpace: 'normal',
  },
}));

export default function BrandObjectListItem({
  object, id, linkColumnsMap,
}) {
  const classes = useStyles();
  const elements = Object.entries(object);

  return (
    <StyledTableRow>
      {
        elements.map((entry, index) => {
          const columnName = entry[0];
          const isLinkColumn = linkColumnsMap && linkColumnsMap[columnName];

          // Check if the value is a link object
          if (entry[1] && typeof entry[1] === 'object' && entry[1].isLink) {
            return (
              <StyledTableCell
                key={`${id}-${index}`}
                id={`${id}-${index}`}
                className={isLinkColumn ? 'link-cell' : ''}
              >
                <Typography
                  variant="body2"
                  component="a"
                  href={entry[1].href}
                  target={entry[1].target}
                  rel={entry[1].rel}
                  style={{
                    color: '#1976d2',
                    textDecoration: 'none',
                    cursor: 'pointer'
                  }}
                >
                  {entry[1].value}
                </Typography>
              </StyledTableCell>
            );
          }

          return (
            <StyledTableCell
              id={`${id}-${index}`}
              component="td"
              className={classes.cellwrap}
            >
              {entry[1]}
            </StyledTableCell>
          );
        })
      }
    </StyledTableRow>
  );
}
BrandObjectListItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  object: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  linkColumnsMap: PropTypes.object,
};
